export default __webpack_public_path__ + "static/logn-d68957c7b00f702f6a25d70b95dc3912.png";